export default __webpack_public_path__ + "static/media/about_anime.986764c2.gif";